import { render } from "./OtherPgCalculator.vue?vue&type=template&id=2072d665"
import script from "./OtherPgCalculator.vue?vue&type=script&lang=js"
export * from "./OtherPgCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__